/*
作用：把时间补0格式化
参数：hh小时;mm分钟;ss秒钟;partition分隔符，如':'
*/
//import { reject } from 'core-js/es6/promise';
import http from '../../http/index.js';
export function formatZero(hh, mm, ss, partition) {
	hh = hh < 10 ? '0' + hh : hh;
	mm = mm < 10 ? '0' + mm : mm;
	ss = ss < 10 ? '0' + ss : ss;
	partition = partition === undefined ? ':' : partition;
	return hh + partition + mm + partition + ss;
}

/*
作用：时间戳转时分秒
参数：timeStamp-时间戳；partition-分隔符；rightNow-true为当前时分秒，false为总时分秒
*/
export function formatHMS(timeStamp, partition, rightNow, isDay) {
	if (rightNow) {
		let date = new Date(timeStamp);
		let hours = date.getHours();
		let minutes = date.getMinutes();
		let seconds = date.getSeconds();
		return formatZero(hours, minutes, seconds, partition);
	} else {
		let days = parseInt((timeStamp / (1000 * 60 * 60 * 24)));
		let hours = parseInt((timeStamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		let minutes = parseInt((timeStamp % (1000 * 60 * 60)) / (1000 * 60));
		let seconds = parseInt((timeStamp % (1000 * 60)) / 1000);
		if (isDay) {
			return days + '天' + hours + partition + minutes + partition + seconds;
		} else {
			return hours + partition + minutes + partition + seconds;
		}
	}
}

/*
作用：前值大于等于后值返回true，否则返回false
*/
export function startGeEnd(startTime, endTime) {
	if (startTime > endTime) {
		return true;
	} else {
		return false;
	}
}

export function prependZero(value) {
	value = value < 10 ? '0' + value : value;
	return value;
}

/*
作用：返回当前时间戳的时分秒转换后的秒数
*/
export function transformSeconds(timestamp) {
	let date = new Date(timestamp);
	var hours = Number(date.getHours()) * 3600;
	var minutes = Number(date.getMinutes()) * 60;
	var seconds = Number(date.getSeconds());
	return hours + minutes + seconds;
}

/*
作用：时分秒转秒
*/
export function hmsToSec(time) {
	let [h, m, s] = time.split(':');
	h = h * 3600;
	m = m * 60;
	s = h + m + parseInt(s);
	return s;
}

export function secToHMS(sec) {
	let h = parseInt(sec / 3600);
	let m = parseInt(sec % 3600 / 60);
	let s = sec % 3600 % 60;
	return `${h}:${m}:${s}`;
}

/*
作用：无限递归嵌套
*/
export function recursiveNested(arr, startArr) {
	startArr.children = [];
	for (let item of arr) {
		(Number(item.pid) === Number(startArr.id)) && startArr.children.push(recursiveNested(arr, item));
	}
	return startArr;
}

/*
作用：无限递归获取用户id
*/
export function getChildrenIds(arr, startId) {
	let tempArr = [startId];
	for (let item of arr) {
		(Number(item.pid) === Number(startId)) && (tempArr = tempArr.concat(getChildrenIds(arr, item.id)));
	}
	// console.log("tempArr--------->", tempArr);
	return tempArr;
}

// 找到父节点的所有id

function isExit(arr, id) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].id == id) {
			return true;
		}
		if (arr[i].child.length != 0) {
			isExit(arr[i].child, id)
		}
	}
	return false
}

export function getFatherIds(arr, startPid, res) {
	let result = res;
	let array = arr;
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].id == startPid) {
			result.push(arr[i]);
			break;
		}
		if (arr[i].child.length != 0) {
			getFatherIds(arr[i].child, startPid, result)
		}
	}
	if (isExit(array, result[result.length - 1].pid)) {
		getFatherIds(array, result[result.length - 1].pid, result);
	} else {
		return result;
	}

	return result;
}

//获取子机构的ids
export function getChildrenGroupIds(Array, start) {
	let res = start;
	for (let i = 0; i < Array.length; i++) {
		res.push(Array[i].id);
		if (Array[i].child.length != 0) {
			getChildrenGroupIds(Array[i].child, res)
		}
	}
	return res.toString();
}

//获取用户group_ids

// export function getGroupIds(array,id,result){
// 	let res = result;
// 	for(let i=0;i<array.length;i++){
// 		res.push(array[i].id);
// 		if(array[i].child.length!=0){
// 			getGroupIds(array,)
// 		}
// 	}
// }

/*
作用：无限递归获取用户在线设备数量
*/
// export function getOnlineTotal(arr, startId) {
// 	let tempArr = [startId];
// 	for (let item of arr) {
// 		(Number(item.pid) === Number(startId)) && (tempArr = tempArr.concat(getOnlineTotal(arr, item.id)));
// 	}
// 	// console.log("tempArr--------->", tempArr);
// 	return tempArr;
// }

export function getOnlineTotal(count, arr) {
	let tempArr = count;
	for (let i in arr) {
		tempArr += arr[i].count;
		if (arr[i].child.length != 0) {
			console.log('...执行...', tempArr)
			getOnlineTotal(tempArr, arr[i].child)
		}
	}
	// console.log("tempArr--------->", tempArr);
	return tempArr;
}

/*
作用：格式化一周选择的指定日期
*/
export function daysWeek(validWeek) {
	const sevenDays = [{
		id: 0,
		name: '日',
		value: Math.pow(2, 0)
	}, {
		id: 1,
		name: '一',
		value: Math.pow(2, 1)
	}, {
		id: 2,
		name: '二',
		value: Math.pow(2, 2)
	}, {
		id: 3,
		name: '三',
		value: Math.pow(2, 3)
	}, {
		id: 4,
		name: '四',
		value: Math.pow(2, 4)
	}, {
		id: 5,
		name: '五',
		value: Math.pow(2, 5)
	}, {
		id: 6,
		name: '六',
		value: Math.pow(2, 6)
	}];
	let daysWeek = [];
	for (let item of sevenDays) {
		(validWeek & item.value) && daysWeek.push(item.name);
	}
	return daysWeek.join(' | ');
}

export function powerAndCard(valid) {
	const list = [{
		id: 0,
		name: '1',
		value: Math.pow(2, 0)
	}, {
		id: 1,
		name: '2',
		value: Math.pow(2, 1)
	}, {
		id: 2,
		name: '3',
		value: Math.pow(2, 2)
	}, {
		id: 3,
		name: '4',
		value: Math.pow(2, 3)
	}, {
		id: 4,
		name: '5',
		value: Math.pow(2, 4)
	}, {
		id: 5,
		name: '6',
		value: Math.pow(2, 5)
	}, {
		id: 6,
		name: '7',
		value: Math.pow(2, 6)
	}, {
		id: 7,
		name: '8',
		value: Math.pow(2, 7)
	}, {
		id: 8,
		name: '①',
		value: Math.pow(2, 8)
	}, {
		id: 9,
		name: '②',
		value: Math.pow(2, 9)
	}, {
		id: 10,
		name: '③',
		value: Math.pow(2, 10)
	}];
	let powerCardList = [];
	for (let item of list) {
		(valid & item.value) && powerCardList.push(item.name);
	}
	return powerCardList.join(',');
}
/*
作用：创建一个定时器，并在路由切换，销毁前清除
*/
export function creatInterval(msg, timeout, vm) {
	let timer = setInterval(msg, timeout);
	vm.$store.commit("TIMER_MYWEBSOCKET_TIMEOUT", timer);
	vm.$once('hook:beforeDestroy', function () {
		clearInterval(timer);
	});
}

/*
作用：返回一组对应关系的对象
*/
export function relationMap(data) {
	if (!data.length) {
		return null;
	}
	let temp = {};
	for (let i = 0; i < data.length; i++) {
		let item = data[i];
		temp[item.id] = item.name;
	}
	return temp;
}

/**
 * Created by admin on 2017/9/27.
 * 时间格式化
 * param {String, String}
 * date: new Date()； fmt: 格式化之后格式(yyyy-MM-dd hh:mm:ss),年月日时分秒可选
 */
export function formatDate(date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(date.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	}
	let o = {
		"M+": date.getMonth() + 1,
		"d+": date.getDate(),
		"h+": date.getHours(),
		"m+": date.getMinutes(),
		"s+": date.getSeconds()
	};
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + "";
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
			);
		}
	}
	return fmt;
}

export function getBase64Image(img) {
	let canvas = document.createElement("canvas");
	canvas.width = img.width;
	canvas.height = img.height;
	let ctx = canvas.getContext("2d");
	ctx.drawImage(img, 0, 0, img.width, img.height);
	let ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
	let dataURL = canvas.toDataURL("image/" + ext);
	return dataURL;
}

/*
作用：异步返回一个base63图片
*/
export function newImage(url) {
	return new Promise(function (resolve, reject) {
		const image = new Image();
		image.setAttribute('crossOrigin', 'anonymous');
		image.src = url;
		image.onload = function () {
			resolve(image);
		};
		image.onerror = function () {
			reject(new Error('Could not load image at ' + url));
		};
		image.src = url;
	}).then(
		res => {
			return getBase64Image(res);
		},
		err => {
			console.log('err----->', err);
			return false;
		},
	);
}

/**
 * @description: 查找素材文件列表
 * @param {文件列表} fileList
 * @param {查找文件id} id
 * @return {返回查找结果}
 */
export function getFileChild(fileList, id) {
	for (let i = 0; i < fileList.length; i++) {
		if (fileList[i].id == id) {
			return fileList[i].child;
		} else if (fileList[i].child.length > 0) {
			let child = getFileChild(fileList[i].child, id);
			if (child) {
				return child;
			}
		}
	}
	return false;
}

export function getBreadcrumb(fileList, id, breadcrumb = []) {
	for (let i = 0; i < fileList.length; i++) {
		if (fileList[i].id == id) {
			breadcrumb.push(fileList[i]);
			return breadcrumb;
		} else if (fileList[i].child.length > 0) {
			if (getBreadcrumb(fileList[i].child, id, breadcrumb)) {
				breadcrumb.push(fileList[i]);
				return breadcrumb;
			}
		}
	}
	return false;
}

export function createFileChunk(file, length = 1) {
	const fileChunkList = [];
	const chunkSize = Math.ceil(file.size / length);
	let cur = 0;
	while (cur < file.size) {
		fileChunkList.push({
			file: file.slice(cur, cur + chunkSize)
		});
		cur += chunkSize;
	}
	return fileChunkList;
}

export function getOrganization(fileList, groupId) {
	for (let i = 0; i < fileList.length; i++) {
		if (fileList[i].group_id == groupId) {
			return fileList[i];
		} else if (fileList[i].child.length > 0) {
			let child = getOrganization(fileList[i].child, groupId);
			if (child) {
				return child;
			}
		}
	}
	return false;
}

// export function getGroupBreadcrumb(fileList, id, breadcrumb = []) {
// 	for (let i = 0; i < fileList.length; i++) {
// 		if (fileList[i].group_id == id) {
// 			breadcrumb.push(fileList[i]);
// 			return breadcrumb;
// 		} else if (fileList[i].child.length > 0) {
// 			if (getGroupBreadcrumb(fileList[i].child, id, breadcrumb)) {
// 				breadcrumb.push(fileList[i]);
// 				return breadcrumb;
// 			}
// 		}
// 	}
// 	return false;
// }


export function sendCommandKp(deviceSelectMode, deviceInfo, type = 'set', data, commanType = "invoke_method") {
	return new Promise((resolve) => {
		http.post("/admin/command/generalCommand", {
			device_select_mode: deviceSelectMode,
			devices_info: encodeURIComponent(JSON.stringify(deviceInfo)),
			request_type: type,
			commands_info: encodeURIComponent(JSON.stringify([{
				type: commanType,
				data
			}]))
		}, data => {
			resolve(data);
		})
	}).then(
		res => {
			return res;
		}
	)
}

export function groupByTerminal(terminalList, groupName) {
	let map = {};
	let res = [];
	for (let i = 0; i < terminalList.length; i++) {
		let ai = terminalList[i];
		if (!map[ai[groupName]]) {
			map[ai[groupName]] = [ai];
		} else {
			map[ai[groupName]].push(ai);
		}
	}
	Object.keys(map).forEach((key) => {
		res.push({
			[groupName]: key,
			list: map[key],
		});
	});
	return res;
}

export function tableScrollToRow(tableElement, rowIndex) {
	const theTableRows = tableElement.bodyWrapper.querySelectorAll('.el-table__body tbody .el-table__row');
	let scrollTop = 0;
	for (let i = 0; i < theTableRows.length; i++) {
		if (i === rowIndex) { break; }
		scrollTop += theTableRows[i].offsetHeight;
	}
	tableElement.bodyWrapper.scrollTop = scrollTop;
}